import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HolidayActions } from './holiday.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HolidayService } from '@core/services/holiday.service';

@Injectable()
export class HolidayEffects {
  private actions$ = inject(Actions);
  private holidayService = inject(HolidayService);
  private translateService = inject(TranslateService);
  getHolidays$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HolidayActions.loadHolidays),
      mergeMap((data) =>
        this.holidayService.getHolidays(data).pipe(
          map((holidays) =>
            holidays.success
              ? HolidayActions.loadHolidaysSuccess(holidays)
              : HolidayActions.loadHolidaysFailure(holidays)
          ),
          catchError((error) =>
            of(
              HolidayActions.loadHolidaysFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addHoliday$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HolidayActions.addEditHoliday),
      mergeMap((data) =>
        this.holidayService.addHoliday(data).pipe(
          map((holiday) => {
            if (holiday.success) {
              return data.id
                ? HolidayActions.updateHolidaySuccess(holiday)
                : HolidayActions.addHolidaySuccess(holiday);
            } else return HolidayActions.addHolidayFailure(holiday);
          }),
          catchError((error) =>
            of(
              HolidayActions.addHolidayFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  deleteHoliday$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HolidayActions.deleteHoliday),
      mergeMap((data) =>
        this.holidayService.deleteHoliday(data.id).pipe(
          map((response) =>
            response.success
              ? HolidayActions.deleteHolidaySuccess({
                  ...response,
                  id: data.id,
                })
              : HolidayActions.deleteHolidayFailure(response)
          ),
          catchError((error) =>
            of(
              HolidayActions.deleteHolidayFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
